// extracted by mini-css-extract-plugin
export default {"cell":"VirtualTableRowCell-cell-_Qpcm TableRowCell-cell-giPrj"};